import { memo } from "react";

import { getTariffLabel } from "@/common/lib";
import { TARIFF_LABELS } from "@/common/model";

interface TradeDirectionRowProps {
  station: React.ReactNode;
  tariff: string | null;
  offer: string | number | null;
}

export const TradeDirectionRow = memo(function TradeDirectionRow({
  station,
  tariff,
  offer,
}: TradeDirectionRowProps) {
  const isCoefficient = tariff != null && getTariffLabel(tariff) === TARIFF_LABELS.COEFFICIENT;

  const offerDisplay =
    offer != null && offer !== "" ? `${offer} ${isCoefficient ? "коэф." : "руб."}` : "-";

  return (
    <div className="grid grid-cols-4 md:grid-cols-3 gap-1 md:gap-4 mb-5 md:mb-0 last:mb-0 ">
      <p className="font-normal text-sm leading-5 py-1 col-span-4 md:col-span-1">{station}</p>
      <p className="font-normal text-sm leading-5 py-1 col-span-2 md:col-span-1">
        {getTariffLabel(tariff ?? undefined)}
      </p>
      <p className="font-normal text-sm leading-5 py-1 col-span-2 md:col-span-1">{offerDisplay}</p>
    </div>
  );
});
